import lodash from 'lodash'
import Drag from '@/classes/Drag'

class Mask {

  /**
   * Just a wrap for iterateElements
   *
   * @param {Object} data - The whole dataset
   */
  static buildStructure(data) {
    let root_el = this.findChildren(data, "root")
    let root_el_keys = Object.keys(root_el).sort(function(keya, keyb) {
      return root_el[keya].position - root_el[keyb].position
    })
    let elements = this.iterateElements(data, root_el_keys)
    return elements
  }

  /**
   * Will list every field inside elements list
   *
   * @param {Object} data - The whole dataset
   * @return {Array} data - the list of fields
   */
  static listFields(data) {
    if (!data) { return [] }
    let fields = []
    let removeFields = ['position', 'parent_element', 'required']
    Object.keys(data).forEach((key) => {
      let element = data[key]
      Object.keys(element).forEach((eKey) => {
        if (removeFields.includes(eKey)) {
          delete element[key]
        }
      })
      // Set the elements name into the object also
      element.name          = key
      let defaultAttributes = Drag.generateElement(element.element_type)
      element               = Object.assign({}, defaultAttributes, element)
      fields.push(element)
    })
    return fields
  }

  /**
   * Will check if there is children elements, if there is
   * the function called itself with the same data and a
   * different data_keys
   *
   * @param {Object} data - The whole dataset
   * @param {Array} data_keys - List of elements
   */
  static iterateElements(data, data_keys) {
    let elements = []
    for (let i = 0; i < data_keys.length; i++) {
      let element = data[data_keys[i]]
      element.name = data_keys[i]
      elements[i] = element

      let children = this.findChildren(data, data_keys[i])
        // We sort the keys by position
      let children_keys = Object.keys(children).sort(function(keya, keyb) {
        return children[keya].position - children[keyb].position
      })
      if (children_keys.length > 0) {
        elements[i].children = this.iterateElements(data, children_keys)
      }
      // Set shouldNotChangeRoute in order to make folded navigation work in lead edit screen
      elements[i].shouldNotChangeRoute = true
    }
    return elements
  }

  /**
   * Will find all elements that has the parent_name
   * as `parent_element`
   * @param {Object} data - The whole dataset
   * @param {String} parent_name - List of elements
   * @return {Object} Filtered data object
   */
  static findChildren(data, parent_name) {
    return _.pickBy(data, function(element) {
      return element.parent_element == parent_name
    })
  }

}

export default Mask



// WEBPACK FOOTER //
// ./src/classes/Mask.js